import { useEffect, useState } from 'react';
import { FormControl, FormLabel, VStack } from '@chakra-ui/react';

import StrongModal from '../common/StrongModal';
import StrongInput from '../common/StrongInput';
import StrongImageDragDrop from '../common/StrongImageDragDrop';
import StrongTextarea from '../common/StrongTextarea';
import StrongSingleSelect from '../common/StrongSingleSelect';

interface EditRestDayModalProps {
  selectedRestDay?: RestDay;
 isOpen: boolean;
  onClose: () => void;
  onSubmit: (
    title: string,
    description: string,
    thumbnail: File | null,
    selectvideo: string,
  ) => void;
  videostitle: VideoTitle[];
  // isLoading?: boolean;
}

const EditRestDayModal = ({
  selectedRestDay,
  isOpen,
  onClose,
  onSubmit,
  videostitle,
}: EditRestDayModalProps) => {
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [thumbnail, setThumbnail] = useState<File | null>(null);
  const [selectvideo, setSelectVideo] = useState<string>('');
  console.log('selectedRestDay', selectedRestDay);

  useEffect(() => {
    setTitle(selectedRestDay?.title || '');
    setDescription(selectedRestDay?.description || '');
    setThumbnail(null);
    setSelectVideo(selectedRestDay?.videoId || "");
  }, [selectedRestDay]);

  return (
    <StrongModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit(title, description, thumbnail, selectvideo)}
      title={selectedRestDay ? 'Edit Rest Day' : 'Create Rest Day'}
      isSubmitDisabled={!title}
      body={
        <VStack spacing={4} align='stretch'>
          <FormControl>
            <FormLabel color='gray.600'>Title</FormLabel>
            <StrongInput
              placeholder='Enter title'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Description</FormLabel>
            <StrongTextarea
              placeholder='Enter description'
              rows={5}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Thumbnail</FormLabel>
            <StrongImageDragDrop
              onFileSelect={setThumbnail}
              defaultImageUrl={selectedRestDay?.thumbnail}
            />
          </FormControl>
          <FormControl>
            <FormLabel color='gray.600'>Related Video</FormLabel>
             <StrongSingleSelect
              options={videostitle?.map(({ title, vimeoId }) => ({ label: title, value: vimeoId })) || []}
              value={
                videostitle
                  .filter((videotitle) => videotitle.vimeoId == selectvideo)
                  .map((videotitle) => ({
                    label: videotitle.title,
                    value: videotitle.vimeoId,
                  }))}
              onSelectChange={setSelectVideo}
            />
          </FormControl>
        </VStack>
      }
    />
  );
};

export default EditRestDayModal;
